var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("div", { staticClass: "successHeader" }, [
            _c("img", { attrs: { src: _vm.rightImg, alt: "" } }),
            _vm._v(" "),
            _c("h4", [_vm._v("评论成功")]),
            _vm._v(" "),
            _c("p", [_vm._v("感谢您的评价")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btnStyle" }, [
            _c(
              "div",
              { staticStyle: { margin: "30px auto 10px auto", width: "80%" } },
              [
                _c(
                  "van-button",
                  {
                    attrs: { round: "", type: "danger", size: "large" },
                    on: { click: _vm.returnFn }
                  },
                  [_vm._v("返回首页")]
                )
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }